import { render, staticRenderFns } from "./PrenotazioniPage.vue?vue&type=template&id=3d01e63e"
import script from "./PrenotazioniPage.vue?vue&type=script&lang=js"
export * from "./PrenotazioniPage.vue?vue&type=script&lang=js"
import style0 from "./PrenotazioniPage.vue?vue&type=style&index=0&id=3d01e63e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports